export const environment = {
  production: false,
  apiUrl: 'https://management.cognos-bot.ai/management-api/',
  azure: {
    clientId: '1c1cbd34-7961-403f-b6a2-65e8a1d9fe96',
    tenant: '5c384fed-84cc-44a6-b34a-b060bf102a6e',
    // Must match Azure AD app registration redirect
    redirectUri: 'https://management.cognos-bot.ai/login',
  },
  postLoginPath: '/home',
};
